module.exports = __webpack_public_path__ + "img/promotion-nav.054c734d.png";